import React, { Component  } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import queryString from 'query-string';
import { Checkbox } from '../../forms';
import './assortment.scss';
import './facet-item.scss';

class OtherInformation extends Component {
    state = {
        otherinformations: []
    };

    componentDidMount() {
        this.setState({
            otherinformations: this.props.otherinformation
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps && (prevProps.otherinformation !== this.props.otherinformation)) {  
            const { otherinformation } = this.props;

            const hasMoreFacets = (otherinformation && otherinformation[0].facetValues.filter(item => item.count > 0).length) > (this.state.otherinformation && this.state.otherinformation[0].facetValues.filter(item => item.count > 0).length);
            this.setState({
                otherinformations: hasMoreFacets || !this.props.isOpen ? this.props.otherinformation : this.state.otherinformations
            });
        }
    }

    render() {
        const { location, submitForm } = this.props;
        const { otherinformations } = this.state;
        const { otherinformation} = queryString.parse(location.search);
    
        return  (
            <div className="assortment">
                {otherinformations && otherinformations[0] && otherinformations[0].facetValues.map((m => {
                    return (
                        <label key={`otherinformations${m.label}`} className={classNames({
                            'facet-item': true,
                            'facet-item--is-visible': m.count > 0,
                            'facet-item--is-disabled': m.count === 0 && (otherinformation && otherinformation.indexOf(m.label) > -1),
                        })}>
                            <Checkbox name="otherinformation" value={m.label} onChange={submitForm} defaultChecked={otherinformation && otherinformation.indexOf(m.label) > -1} /> 
                            <>
                                <span>{m.label}</span>
                                <span className="facet-item__count">{m.count}st</span>
                            </>
                        </label>
                    );
                }))}
            </div>
        );
    }
    
};

export default withRouter(OtherInformation);